// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/lobby/" + {"16":"branding-halloween","369":"branding-christmas"}[chunkId] + "." + {"16":"6bde5782","369":"c33bc20c"}[chunkId] + ".chunk.js";
};